import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsString, IsUUID, MaxLength } from 'class-validator';
import { UserDto } from '../../user/dto/user.dto';
import { JobDto } from '../../job/dto/job.dto';
import { JobNoteInterface } from '../interfaces/job-note.interface';
import { JobNoteOptionDto } from '../../job-note-option/dtos/job-note-option.dto';

@Exclude()
export class JobNoteDto extends CommonEntityDto implements JobNoteInterface {
  @IsString()
  @MaxLength(1000)
  @ApiProperty({
    title: 'Job Note',
    minLength: 1,
    maxLength: 5000,
    nullable: true,
  })
  @IsString()
  @MaxLength(5000)
  @Expose()
  note!: string | null;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Repair ID',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Associated Job Repair ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  jobNoteOptionId!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  user?: UserDto;

  @ApiPropertyOptional({
    type: () => [JobDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  job?: JobDto;

  @ApiPropertyOptional({
    type: () => [JobNoteOptionDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  jobNoteOptions?: JobNoteOptionDto[];
}
